var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-row",
        { attrs: { gutter: 24 } },
        [
          _c(
            "el-form",
            { attrs: { model: _vm.form, "label-width": "80px" } },
            [
              _c(
                "el-col",
                { staticClass: "mb-16", attrs: { span: 24 } },
                [
                  _c(
                    "el-card",
                    [
                      _c(
                        "el-form-item",
                        {
                          staticStyle: { "margin-bottom": "0" },
                          attrs: { label: _vm.$t("watermark::页面水印") },
                        },
                        [
                          _c("el-switch", {
                            attrs: { "active-value": 1, "inactive-value": 0 },
                            model: {
                              value: _vm.form.status,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "status", $$v)
                              },
                              expression: "form.status",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm.form.status
                ? _c(
                    "div",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 14 } },
                        [
                          _c(
                            "el-card",
                            [
                              _c("p", { staticClass: "watermark-title" }, [
                                _vm._v(_vm._s(_vm.$t("watermark::水印设计"))),
                              ]),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("watermark::水印名称"),
                                  },
                                },
                                [
                                  _vm.form.userName
                                    ? _c("el-input", {
                                        attrs: {
                                          value: _vm.$store.state.user.userName,
                                          disabled: _vm.form.userName,
                                        },
                                      })
                                    : _c("el-input", {
                                        attrs: { disabled: _vm.form.userName },
                                        model: {
                                          value: _vm.form.text,
                                          callback: function ($$v) {
                                            _vm.$set(_vm.form, "text", $$v)
                                          },
                                          expression: "form.text",
                                        },
                                      }),
                                  _c(
                                    "el-checkbox",
                                    {
                                      on: { change: _vm.changeName },
                                      model: {
                                        value: _vm.form.userName,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.form, "userName", $$v)
                                        },
                                        expression: "form.userName",
                                      },
                                    },
                                    [
                                      _c(
                                        "span",
                                        { staticStyle: { color: "#999999" } },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("watermark::use-userName")
                                            )
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                { attrs: { label: _vm.$t("watermark::字号") } },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      model: {
                                        value: _vm.form.fontSize,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.form, "fontSize", $$v)
                                        },
                                        expression: "form.fontSize",
                                      },
                                    },
                                    _vm._l(89, function (num) {
                                      return _c("el-option", {
                                        key: num,
                                        attrs: {
                                          label: num + 11,
                                          value: num + 11,
                                        },
                                      })
                                    }),
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                { attrs: { label: _vm.$t("watermark::颜色") } },
                                [
                                  _c("el-color-picker", {
                                    model: {
                                      value: _vm.form.color,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.form, "color", $$v)
                                      },
                                      expression: "form.color",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  staticStyle: { "margin-bottom": "0" },
                                  attrs: { label: _vm.$t("watermark::透明度") },
                                },
                                [
                                  _c("el-slider", {
                                    staticStyle: {
                                      display: "inline-block",
                                      width: "85%",
                                    },
                                    attrs: { min: 10 },
                                    model: {
                                      value: _vm.form.opacity,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.form, "opacity", $$v)
                                      },
                                      expression: "form.opacity",
                                    },
                                  }),
                                  _c("span", { staticClass: "opacity" }, [
                                    _vm._v(_vm._s(_vm.form.opacity) + "%"),
                                  ]),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 10 } },
                        [
                          _c("el-card", [
                            _c("p", { staticClass: "watermark-title" }, [
                              _vm._v(_vm._s(_vm.$t("watermark::水印预览"))),
                            ]),
                            _c("div", {
                              staticClass: "preview",
                              attrs: { id: "previewShowWrap" },
                            }),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "footer-fixed",
        [
          _c(
            "el-button",
            {
              attrs: { type: "primary", loading: _vm.loading },
              on: { click: _vm.submit },
            },
            [_vm._v(_vm._s(_vm.$t("watermark::保存")))]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }